import React, { Component } from 'react';
// local
import Page from 'app/ui/pages/Page';
// images
import notFound from 'app/_assets/img/ic_notfound.png';
// CSS import
import './NotFound.scss';

class NotFound extends Component {
    render() {
        return (
        <Page id="page-notfound">
                <div className="notfound">
                    <img src={notFound} alt="Not Found"/>
                    <div>Página não encontrada</div>
                </div>
        </Page>
    );
    }
}

export default NotFound;
